import { AnnouncementsService } from './shared/announcements.service';
import { FilterPipe } from '../shared/pipes/filter.pipe';
import { SharedModule } from '../shared/shared.module';
import { AnnouncementsRoutingModule } from './announcements-routing.module';
import { AnnouncementsComponent } from './announcements.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnnouncementDetailComponent } from './announcement-detail/announcement-detail.component';
import { AnnouncementEditComponent } from './announcement-edit/announcement-edit.component';
import { FormsModule } from '@angular/forms';
import { MomentModule } from 'angular2-moment';
import { MarkdownModule } from 'angular2-markdown';
import { AnnouncementViewComponent } from './announcement-view/announcement-view.component';

@NgModule({
  imports: [AnnouncementsRoutingModule, CommonModule, FormsModule, MomentModule, MarkdownModule, SharedModule],
  declarations: [AnnouncementsComponent,
    AnnouncementDetailComponent,
    AnnouncementEditComponent,
    AnnouncementViewComponent
  ],
  providers: [AnnouncementsService],
  exports: [AnnouncementsComponent]
})
export class AnnouncementsModule { }



// WEBPACK FOOTER //
// /ng-app/src/app/announcements/announcements.module.ts